import React, { useState } from "react"
import {
  Card,
  CardBody, Row, Col
} from "reactstrap"
import SimpleBar from "simplebar-react"
import PropTypes from 'prop-types';

const Timeline = props => {
 
    const notofications = [
        {  desc: "Set IPA"  },
        {  desc: "IPA Approval"  },
        {  desc: "Mid-term Appraisal"  },
        {  desc: "Full-term Appraisal"  },
        {  desc: "Appraisal Closed" },
        {  desc: "PI Plan"   }
      ]

      return (

            <Card>
            <h5 className="card-header bg-transparent border-bottom text-uppercase text-primary">Timeline</h5>
                <CardBody>
            
                <SimpleBar style={{ height: "380px" }}>
                    <ul className="verti-timeline list-unstyled">
                    {notofications.map((notification, key) => (
                    <li key={key} className="event-list">
                        <div className="event-timeline-dot">
                        <i className={(key == props.stage) ? `bx bx-right-arrow-circle font-size-20 text-danger bx-fade-right`:`bx bx-right-arrow-circle font-size-18`} />
                        </div>
                        <div className="d-flex">
                        <div className="me-3">
                            <h5 className="font-size-14">
                            {notification.date}{" "}
                            <i className={(key == props.stage)? `bx bx-right-arrow-alt font-size-16 text-danger align-middle ms-2 bx-fade-right` : `bx bx-right-arrow-alt font-size-16  align-middle ms-2`}/>
                            </h5>
                        </div>
                        <div className="flex-grow-1">
                            <div>{(key == props.stage) ? <strong className="text-primary">{notification.desc}</strong> : <>{notification.desc}</>} </div>
                        </div>
                        </div>
                    </li>
                    ))}
                    </ul>
                    </SimpleBar>
                </CardBody>
                </Card>
    )
  }
  Timeline.propTypes = {
    stage: PropTypes.any
  };
  export default Timeline